import type { CanBuilder } from "../types";
import type { GetEpsQuestionnaireApiResponse } from "@/services/schemas";
import { defineSpecialistRules } from "./specialist";

type EpsQuestionnaireUpdateConditions = {
	status: GetEpsQuestionnaireApiResponse["status"][0]["label"];
};

type EpsQuestionnaireSubmitConditions = {
	status: GetEpsQuestionnaireApiResponse["status"][0]["label"];
	sections: GetEpsQuestionnaireApiResponse["sections"];
};

export function defineEticoRules(can: CanBuilder): void {
	defineSpecialistRules(can);

	can("create", "EPS");
	can("update", "EPS");

	can("create", "EPSQuestionnaire");

	can(
		"update",
		"EPSQuestionnaire",
		({ status }: EpsQuestionnaireUpdateConditions) =>
			status === "Em elaboração" || status === "Em edição",
	);

	can(
		"submit",
		"EPSQuestionnaire",
		({ status, sections }: EpsQuestionnaireSubmitConditions) =>
			(status === "Em elaboração" || status === "Em edição") &&
			sections.every(({ questions }) => questions.length > 0),
	);
}
